export const white = '#fff';
export const red = '#FF3D00';
export const orange = '#FA5F1C';
export const yellow = '#FFE87A';
export const fontColorPrim = '#4D4D4F';
export const black = '#000';
export const green = '#0AAF60';
export const fontColorSecond = '#ABB2BF';
export const accentColorPrim = '#00AAD5';
export const accentColorSecond = '#DCE6F7';
export const accentColorTertiary = '#F2F3F5';

export const bpSm = '768px';
export const bpMd = '991px';
export const bpLg = '1024px';
export const bpXl = '1280px';
export const bpXxl = '1440px';
